import { useContext } from 'react';

import type { PetitionStatsState } from '#src/app/pages/petitionDetails/shared/types';

import { PetitionStatsContext } from '../context';

export type { PetitionStatsState };

export function usePetitionStats(): PetitionStatsState {
	const context = useContext(PetitionStatsContext);

	if (!context) {
		throw new Error('PetitionStatsContext was not set');
	}

	return context;
}
